import React, { useEffect } from 'react'
import { useSession } from 'context/Session'

import { doViewValueProposition } from '../modules/datasource'

import * as S from './ValueProposition.styles'

const defaultProps = {}
const propTypes = {}

export const ValueProposition = () => {
  const { user, accessToken, setSession } = useSession()

  useEffect(() => {
    if (user && !user?.viewedValueProposition) {
      doViewValueProposition({ accessToken })
      setSession({ ...user, viewedValueProposition: true })
    }
  }, [user, accessToken])

  return (
    <S.Container>
      <S.FirstPanel />
      <S.SecondPanel />
      <S.ThirdPanel />
      <S.FourthPanel />
    </S.Container>
  )
}

ValueProposition.defaultProps = defaultProps
ValueProposition.propTypes = propTypes

export default ValueProposition
